export default "__VITE_ASSET__BVDGJe70__"